/**
 * The currencies a user may choose to report in.
 *
 * Pinned from the backend's `api/src/services/fx/currencies.py`,
 * `REPORTING_CURRENCIES`: the Bank of Canada's 28 daily series (27 plus CAD
 * itself) minus VND and RUB, whose series stopped publishing, so a report in
 * either would convert every recent row to nothing. That is 26, not 30: iOS
 * also offers DKK, which the backend rejects. The backend validates; this list
 * only decides what the picker offers, and a test pins it.
 */
export const REPORTING_CURRENCIES = [
  'AUD', 'BRL', 'CAD', 'CHF', 'CNY', 'EUR', 'GBP', 'HKD', 'IDR', 'INR', 'JPY', 'KRW', 'MXN',
  'MYR', 'NOK', 'NZD', 'PEN', 'PLN', 'SAR', 'SEK', 'SGD', 'THB', 'TRY', 'TWD', 'USD', 'ZAR',
] as const

export type ReportingCurrency = (typeof REPORTING_CURRENCIES)[number]
